import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { DeleteImageModalComponent } from './delete-image-modal/delete-image-modal.component';
import { WEBLATE_COMPONENT_NAME } from './shared/constants';
import { UploadImageModalComponent } from './upload-image-modal/upload-image-modal.component';
import { UserProfileComponent } from './user-profile.component';
import { UserProfileService } from './user-profile.service';

export { UserProfileComponent };

export const MODULE_IMPORTS = [
  CommonModule,
  GalaxyInputModule,
  MatCardModule,
  GalaxyPageModule,
  MatButtonModule,
  TranslateModule,
  MatProgressSpinnerModule,
  ReactiveFormsModule,
  LexiconModule.forChild({
    componentName: WEBLATE_COMPONENT_NAME,
    baseTranslation: baseTranslation,
  }),
  MatIconModule,
  GalaxyUploaderModule,
  MatDialogModule,
];

export const MODULE_DECLARATIONS = [UserProfileComponent, UploadImageModalComponent, DeleteImageModalComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [UserProfileComponent, UploadImageModalComponent],
  providers: [UserProfileService],
})
export class UserProfileModule {}
